// RecipeCard.js
import React, { useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import { Link } from 'react-router-dom';
import { FaCheck, FaRegTimesCircle, FaTimesCircle, FaTrash, FaTrashAlt, FaXing } from 'react-icons/fa';

const RecipeSwipable = ({ doc, handleDelete }) => {
    const[showDelete, setShowDelete] = useState(false);
    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => setShowDelete(true),
        onSwipedRight: () => setShowDelete(false), 
        preventDefaultTouchmoveEvent: true,
    });

    return (
        <div key={doc.name} 
        className="relative">
            <div {...swipeHandlers} className="recipe-card">
                <Link to={`/recipeBasic/${doc.id}`} state={{ doc }}>
                    <div className="recipe-card-list-item recipe-gradient">
                        <strong className="text-xl">{doc.name}</strong>
                    </div>
                </Link>
            </div>

            {/* Conditionally Render Delete Button */}
            {showDelete && (
                <div
                    className= {`absolute h-7/8 flex justify-center top-1 right-2 bg-red-500 text-white rounded-r-xl ${showDelete ? "visible" : "invisible"}`}
                    style={{ zIndex: 10, boxShadow: 2 }}
                >
                    <button 
                    className='bg-transparent'
                    onClick={() => handleDelete(doc.name)}>
                     <FaTrashAlt className='text-2xl'></FaTrashAlt>
                    </button>
                </div>
            )}
        </div>
    );
};

export default RecipeSwipable;
